import React from 'react';
import { Text } from '@amzn/atoz-web/Text';
import { CancelSwapRequestModalSuccessButton } from './CancelSwapRequestModalSuccessButton/CancelSwapRequestModalSuccessButton.web';
import { GenericModalTypes, GenericModalWithIconContent } from '../../shared';
import { useTranslation } from 'react-i18next';
import { View } from '@amzn/atoz-web/View';
import { Row } from '@amzn/atoz-web/Row';
import { Col } from '@amzn/atoz-web/Col';
import { DateTime } from 'luxon';
import { timeDifferenceWithDurationString } from '@amzn/atoz-shiftapp-utilities';
export var CancelSwapRequestModalSuccess = function (_a) {
    var close = _a.close, shiftsForDay = _a.shiftsForDay, siteId = _a.siteId;
    var t = useTranslation().t;
    var hasMultipleShifts = shiftsForDay.length > 1;
    // shiftsForDay should always contain at least one element
    // due to how a user navigates to this modal
    // but will handle the theoretically-impossible scenario where it is of length 0
    if (shiftsForDay.length === 0) {
        return (React.createElement(GenericModalWithIconContent, { dataTestId: "CancelSwapRequestModalSuccess_Error", mainText: t('shift_management_features_CancelSwapRequestSuccess_title'), onClose: close, buttons: [
                React.createElement(CancelSwapRequestModalSuccessButton, { onClick: close, key: "OK" })
            ], type: GenericModalTypes.success },
            React.createElement(Col, { gridGap: "S300" },
                React.createElement(Text, { dataTestId: "CancelSwapRequestModalSuccess_description", fontWeight: "medium" }, t('shift_management_features_CancelSwapRequestSuccess_subtitle_multipleShift_generic')))));
    }
    var dateOfShifts = DateTime.fromISO(shiftsForDay[0].shift.timeRange.start);
    return (React.createElement(GenericModalWithIconContent, { dataTestId: "CancelSwapRequestModalSuccess", mainText: t('shift_management_features_CancelSwapRequestSuccess_title'), onClose: close, buttons: [
            React.createElement(CancelSwapRequestModalSuccessButton, { onClick: close, key: "OK" })
        ], type: GenericModalTypes.success },
        React.createElement(Col, { gridGap: "S300", margin: { top: 'S400' } },
            React.createElement(Text, { dataTestId: "CancelSwapRequestModalSuccess_description", fontWeight: "medium" }, hasMultipleShifts
                ? t('shift_management_features_CancelSwapRequestSuccess_subtitle_multipleShift')
                : t('shift_management_features_CancelSwapRequestSuccess_subtitle')),
            React.createElement(Text, { dataTestId: "originalShiftString", lineHeight: 0.5 }, dateOfShifts.toLocaleString({
                weekday: 'short',
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            })),
            React.createElement(View, { backgroundColor: "neutral05", padding: ['S300', 'S400'], margin: { top: 'S100' }, dataTestId: "CancelSwapRequestSuccessModal_OriginalShiftList" },
                shiftsForDay.map(function (_a) {
                    var shift = _a.shift;
                    return (React.createElement(View, { key: "OriginalShift-".concat(shift.timeRange.start, "-").concat(shift.timeRange.end), padding: { top: 'S200', bottom: 'S200' } },
                        React.createElement(Text, { dataTestId: "originalShiftDurationString", fontWeight: "medium" }, timeDifferenceWithDurationString(DateTime.fromISO(shift.timeRange.start), DateTime.fromISO(shift.timeRange.end)))));
                }),
                siteId && (React.createElement(Row, { padding: { top: 'S100' } },
                    React.createElement(Text, null, siteId)))))));
};
